import type { ReactNode } from 'react';
import { cx } from './cx';

type Tone = 'neutral' | 'accent' | 'positive' | 'attention' | 'critical';

const tones: Record<Tone, string> = {
  neutral: 'bg-surface-2 text-text-2',
  accent: 'bg-accent-soft text-accent-text',
  positive: 'bg-positive-soft text-positive',
  attention: 'bg-attention-soft text-attention',
  critical: 'bg-critical-soft text-critical',
};

export function Badge({ tone = 'neutral', children }: { tone?: Tone; children: ReactNode }) {
  return (
    <span
      className={cx(
        'inline-flex h-6 items-center rounded-full px-2.5 text-xs font-medium',
        tones[tone],
      )}
    >
      {children}
    </span>
  );
}
